import React from "react";

import { BsArrowRightShort } from "react-icons/bs";
import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";

const CustomViedoCard = ({ viedoLink, id, name }) => {
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  return (
    <div>
      {" "}
      <div className="col-lg-12 mt-2">
        <div className="card  text-center">
          <div className="ps-5 pe-5 pt-1 pb-3">
            <div className="empty-img"></div>
            <p className="empty-title">Software Explanation</p>
            <p
              className={`empty-subtitle text-secondary ${
                themeSet === "dark" ? "text-light" : ""
              }`}
            >
              {`Watch the video to understand how the ${name} functionality works.`}
            </p>
            <button
              className="btn btn-primary mt-2"
              data-bs-toggle="modal"
              data-bs-target={`#${id}`}
              style={{ height: "30px" }}
            >
              <BsArrowRightShort className="me-1" /> Watch Now
            </button>
            <div
              className="modal modal-blur fade"
              id={`${id}`}
              tabIndex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">How to use Kryzen Softwares</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body text-center px-lg-0 px-md-2">
                    <iframe
                      className="col-lg-10 col-sm-10"
                      width="100%"
                      src={`${viedoLink}`} // Corrected URL format
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      style={{
                        minHeight: "50vh",
                        borderRadius: "10px",
                      }}
                    ></iframe>
                  </div>
                  <div className="modal-footer bg-transparent border-1">
                    <button
                      type="button"
                      className="btn btn-secondary m-0"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomViedoCard;
